import { EMAIL_REGEX } from "../Constants/Constants";

export const checkEmail = (email) => {
  return EMAIL_REGEX.test(email);
};

export const getToken = () => {
  return localStorage.getItem("token");
};
